import axios from 'axios'
import { BadRequest, ServiceUnavailable } from 'common/errors'
import { AccessDenied } from 'common/errors/AccessDenied'

export const publicPageRequest = axios.create({
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

publicPageRequest.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status

    if (status === 503) {
      throw new ServiceUnavailable(error.response)
    }

    if (status === 400 && error.response) {
      throw new BadRequest(error.response)
    } else if (status === 403 || status === 401) {
      const loginWindow = window.open('', 'preview')
      const redirect =
        error.response.data.location || error.response.data.redirect // location will be replaced by redirect
      if (redirect) {
        if (loginWindow) {
          loginWindow.location.href = redirect
        } else {
          location.assign(redirect)
        }
      }
      throw new AccessDenied(error.response)
    }
    throw error
  },
)
